import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { SessionStorageService } from 'ngx-webstorage';
import { AppConstants } from '../constant'

@Injectable({
  providedIn: 'root'
})
export class KycserviceService {

  constructor(private http: Http, private session: SessionStorageService,) { }

 


  check(type, firstname, lastname, idcardname) {
    return new Promise((resolve, reject) => {
      const url = 'http://valobit.io/valobit/junkbox.php';

      const body = { 
          'url': 'http://valobit.io/valobit/user/userkyc',
          'data':
          {
            "token":this.session.retrieve('token'),
            'type': type,
            'first_name': firstname,
            'last_name': lastname,
            'id_card_name': idcardname
          }
        };

      this.http.post(url, body).subscribe((res: any) => {
      const response = JSON.parse(res._body);
      if (response.status) {
          resolve(response);
        } else { reject(response); }
      });
    });
  }

  kycdetail() {
    return new Promise((resolve, reject) => {
      const url = 'http://valobit.io/valobit/junkbox.php';

      const body = { 
          'url': 'http://valobit.io/valobit/user/kycDetail',
          'data':
          {
            "token":this.session.retrieve('token')
          }
        };

      this.http.post(url, body).subscribe((res: any) => {
      const response = JSON.parse(res._body);
      if (response.status) {
          resolve(response);
        } else { reject(response); }
      });
    });
  }
}
